import styles from './index.module.less'

const EmptyContent = () => {
  return (
    <div className={styles.emptyContent}>
      <svg
        width="211"
        height="253"
        viewBox="0 0 211 253"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="105" cy="108.337" r="105" fill="url(#paint0_linear_767_23227)" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M203.691 53.5224C207.387 53.5224 210.382 50.5269 210.382 46.8314C210.382 43.1359 207.387 40.1404 203.691 40.1404C199.996 40.1404 197 43.1359 197 46.8314C197 50.5269 199.996 53.5224 203.691 53.5224ZM203.691 42.3876C206.146 42.3876 208.135 44.3769 208.135 46.8314C208.135 49.2859 206.146 51.2752 203.691 51.2752C201.237 51.2752 199.247 49.2859 199.247 46.8314C199.247 44.3769 201.237 42.3876 203.691 42.3876Z"
          fill="#0064FF"
          fillOpacity="0.3"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M134.163 220.376C137.859 220.376 140.854 217.381 140.854 213.685C140.854 209.99 137.859 206.994 134.163 206.994C130.468 206.994 127.472 209.99 127.472 213.685C127.472 217.381 130.468 220.376 134.163 220.376ZM134.163 209.241C136.618 209.241 138.607 211.231 138.607 213.685C138.607 216.14 136.618 218.129 134.163 218.129C131.709 218.129 129.719 216.14 129.719 213.685C129.719 211.231 131.709 209.241 134.163 209.241Z"
          fill="#0064FF"
          fillOpacity="0.3"
        />
        <g filter="url(#filter0_f_767_23227)">
          <path
            d="M35.0562 121.32L29.9207 119.433L28.0337 114.298L26.1467 119.433L21.0112 121.32L26.1467 123.207L28.0337 128.343L29.9207 123.207L35.0562 121.32Z"
            fill="#0064FF"
            fillOpacity="0.3"
          />
        </g>
        <path
          d="M199.876 163.438L192.243 160.634L189.438 153L186.634 160.634L179 163.438L186.634 166.243L189.438 173.876L192.243 166.243L199.876 163.438Z"
          fill="#0064FF"
          fillOpacity="0.3"
        />
        <path
          d="M91.8286 70.073L51.4241 98.2927C47.6134 100.95 46.8067 106.246 49.628 109.929L75.6847 143.921L134.011 125.945L91.8286 70.073Z"
          fill="#0053CF"
        />
        <path
          d="M162.399 88.9848L136.47 50.5606C133.85 46.6943 128.609 45.65 124.706 48.2331L91.832 70.0747L134.015 125.944L162.399 88.9848Z"
          fill="#0053CF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M125.732 73.719L148.802 68.8263L135.132 48.5606C133.08 45.5364 129.414 44.0336 125.841 44.7488L73.3599 55.3763L105.886 103.55L118.695 79.0511C120.124 76.3213 122.708 74.36 125.732 73.719ZM162.381 88.9466V88.9831H162.399L162.381 88.9466Z"
          fill="url(#paint1_linear_767_23227)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M75.6892 143.903V143.921L77.1173 141.997L75.6892 143.903ZM56.9796 119.513L76.2016 93.419C78.1993 90.6881 81.919 89.8999 84.8499 91.5859L105.832 103.644L105.887 103.552L73.3611 55.3763L47.6521 97.8893C45.7285 101.078 45.9487 105.109 48.2201 108.078L56.9796 119.513ZM105.942 103.662L105.887 103.68L105.905 103.699L105.942 103.662ZM165.349 65.3084L148.803 68.8263L162.381 88.9471L168.611 68.8814C169.253 66.8297 167.439 64.8685 165.349 65.3084Z"
          fill="url(#paint2_linear_767_23227)"
        />
        <path d="M162.376 88.9832L105.938 103.644V103.663L162.376 88.9832Z" fill="#FE506B" />
        <path
          d="M118.692 79.0533L105.865 103.554L105.92 103.646L162.36 88.9854V88.9488L148.781 68.809L125.729 73.7202C122.706 74.3618 120.141 76.3224 118.692 79.0533Z"
          fill="#CAC134"
        />
        <path
          d="M118.692 79.0533L105.865 103.554L105.92 103.646L162.36 88.9854V88.9488L148.781 68.809L125.729 73.7202C122.706 74.3618 120.141 76.3224 118.692 79.0533Z"
          fill="url(#paint3_linear_767_23227)"
        />
        <path
          d="M105.832 103.643L105.888 103.68L105.945 103.662V103.643L105.888 103.551L105.832 103.643Z"
          fill="#FFBA3B"
        />
        <path
          d="M105.832 103.643L105.888 103.68L105.945 103.662V103.643L105.888 103.551L105.832 103.643Z"
          fill="#FE506B"
        />
        <path
          d="M75.6683 143.921V143.903L56.9582 119.494L52.6335 125.358C50.8745 127.74 51.6441 131.131 54.2649 132.505L75.6683 143.921Z"
          fill="url(#paint4_linear_767_23227)"
        />
        <path
          d="M105.905 103.697L77.1182 141.994L105.978 103.733L105.905 103.697Z"
          fill="#FE506B"
        />
        <path
          d="M105.905 103.679L105.868 103.661L105.813 103.697L105.831 103.661L84.8503 91.6039C81.9182 89.9179 78.1986 90.7056 76.2014 93.4179L56.9609 119.492L75.6699 143.899L77.1177 141.993L105.905 103.679Z"
          fill="#FFBA3B"
        />
        <path
          d="M105.831 103.661L84.8503 91.6039C81.9182 89.9179 78.1986 90.7056 76.2014 93.4179L56.9609 119.492L75.6699 143.899L77.1177 141.993L105.905 103.679L105.868 103.661L105.813 103.697L105.831 103.661Z"
          fill="url(#paint5_linear_767_23227)"
        />
        <path d="M105.826 103.646L105.809 103.701L105.88 103.683L105.826 103.646Z" fill="#FFBA3B" />
        <path d="M105.826 103.646L105.809 103.701L105.88 103.683L105.826 103.646Z" fill="#FE506B" />
        <path d="M105.826 103.646L105.809 103.701L105.88 103.683L105.826 103.646Z" fill="#FE506B" />
        <path
          d="M131.446 143.296L134.012 125.944L75.6879 143.919L73.8003 162.151C73.5255 164.918 76.2014 167.043 78.8396 166.145L124.703 150.79C128.111 149.617 130.659 146.777 131.446 143.296Z"
          fill="url(#paint6_linear_767_23227)"
        />
        <path
          d="M170.093 85.3904L162.361 88.9999L133.978 125.977L147.812 114.03C149.498 112.766 151.019 111.3 152.338 109.651L171.706 87.4061C172.585 86.3061 171.376 84.7859 170.093 85.3904Z"
          fill="url(#paint7_linear_767_23227)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M130.055 182.695L134.105 183.904C134.929 184.143 135.956 183.978 136.707 183.465L138.539 182.236C139.895 181.32 139.767 179.836 138.301 179.415L134.453 178.297C133.702 178.095 132.785 178.205 132.053 178.627L130.037 179.763C128.516 180.624 128.534 182.236 130.055 182.695ZM116.056 157.847L118.548 156.601C120.399 155.684 120.692 153.174 119.116 151.836L114.975 148.317C114.169 147.639 113.051 147.438 112.08 147.823L109.386 148.849C107.371 149.636 106.894 152.294 108.562 153.742L112.904 157.461C113.784 158.213 115.03 158.36 116.056 157.847Z"
          fill="#0064FF"
        />
        <path
          d="M34.8764 196.438L27.243 193.634L24.4382 186L21.6334 193.634L14 196.438L21.6334 199.243L24.4382 206.876L27.243 199.243L34.8764 196.438Z"
          fill="#0064FF"
          fillOpacity="0.3"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M183.652 126.095C186.134 126.095 188.146 124.083 188.146 121.601C188.146 119.119 186.134 117.107 183.652 117.107C181.17 117.107 179.157 119.119 179.157 121.601C179.157 124.083 181.17 126.095 183.652 126.095ZM183.652 119.354C184.893 119.354 185.899 120.36 185.899 121.601C185.899 122.842 184.893 123.848 183.652 123.848C182.411 123.848 181.404 122.842 181.404 121.601C181.404 120.36 182.411 119.354 183.652 119.354Z"
          fill="#0064FF"
        />
        <g filter="url(#filter1_d_767_23227)">
          <path
            d="M145.733 99.5505C142.514 99.5505 139.39 100.121 136.447 101.248C133.599 102.338 131.038 103.901 128.84 105.889C126.632 107.887 124.898 110.216 123.685 112.81C122.433 115.472 121.784 118.379 121.786 121.321C121.786 127.428 124.583 133.205 129.496 137.325C127.931 139.375 125.673 141.233 122.315 143.248C122.111 143.37 121.952 143.556 121.864 143.778C121.775 143.998 121.762 144.242 121.826 144.471C121.889 144.701 122.026 144.903 122.216 145.047C122.405 145.192 122.637 145.27 122.875 145.27C126.189 145.27 129.236 144.94 131.931 144.289C134.228 143.735 136.279 142.947 138.037 141.942C140.53 142.708 143.124 143.096 145.733 143.093C148.952 143.093 152.077 142.521 155.019 141.395C157.867 140.307 160.427 138.742 162.626 136.753C164.833 134.756 166.568 132.428 167.781 129.833C169.031 127.17 169.679 124.263 169.679 121.321C169.679 118.38 169.031 115.473 167.781 112.81C166.568 110.216 164.834 107.887 162.626 105.889C160.427 103.9 157.868 102.338 155.019 101.248C152.077 100.121 148.952 99.5505 145.733 99.5505Z"
            fill="url(#paint8_linear_767_23227)"
          />
        </g>
        <path
          d="M143.114 124.937H146.447C146.06 121.267 150.789 120.802 150.789 116.9C150.789 113.618 148.437 111.938 145.207 111.938C142.829 111.938 140.891 113.024 139.444 114.677L141.563 116.642C142.545 115.556 143.553 115.013 144.767 115.013C146.266 115.013 147.145 115.84 147.145 117.236C147.145 119.82 142.545 120.776 143.114 124.937ZM144.793 131.811C146.111 131.811 147.067 130.881 147.067 129.537C147.067 128.167 146.111 127.237 144.793 127.237C143.501 127.237 142.519 128.167 142.519 129.537C142.519 130.881 143.475 131.811 144.793 131.811Z"
          fill="white"
        />
        <g filter="url(#filter2_f_767_23227)">
          <path
            d="M73.4161 15.0787L64.2172 11.6988L60.8374 2.5L57.4577 11.6988L48.2588 15.0787L57.4577 18.4585L60.8374 27.6573L64.2172 18.4585L73.4161 15.0787Z"
            fill="#0064FF"
            fillOpacity="0.3"
          />
        </g>
        <path
          d="M81.016 239.936V241.168L78.84 241.36V242.48H77.432V241.472C76.424 241.536 75.384 241.616 74.296 241.68L74.12 240.368C75.288 240.32 76.392 240.272 77.432 240.208V239.184H74.632L74.312 237.952C74.68 237.536 75.032 237.024 75.384 236.416H73.88V235.072H76.024C76.152 234.752 76.264 234.432 76.392 234.112L77.896 234.352C77.8 234.592 77.72 234.832 77.624 235.072H81.32V236.416H77C76.712 236.96 76.392 237.472 76.072 237.936H77.432V236.992H78.84V237.936H81.176V239.184H78.84V240.112C79.608 240.048 80.328 240 81.016 239.936ZM83.432 239.2C83.24 240.496 82.792 241.632 82.12 242.624L81.064 241.52C81.736 240.528 82.104 239.344 82.136 237.984V235.344C84.216 235.152 85.784 234.8 86.84 234.304L87.832 235.424C86.664 235.936 85.224 236.304 83.528 236.496V237.872H88.152V239.2H86.616V242.496H85.16V239.2H83.432ZM86.52 242.848V249.024H84.984V248.464H77.208V249.024H75.672V242.848H86.52ZM77.208 247.168H84.984V246.224H77.208V247.168ZM77.208 245.024H84.984V244.112H77.208V245.024ZM91.048 234.976H102.696V236.464H97.064V237.424C97.032 238.32 96.968 239.152 96.872 239.952H103.96V241.424H99.128V246.56C99.128 247.072 99.368 247.344 99.864 247.344H101.672C101.992 247.344 102.232 247.232 102.392 247.008C102.568 246.784 102.696 246.048 102.76 244.832L104.184 245.296C104.056 246.976 103.8 247.984 103.448 248.304C103.128 248.608 102.632 248.768 101.96 248.768H99.4C98.216 248.768 97.624 248.128 97.624 246.88V241.424H96.632C96.344 242.8 95.944 243.984 95.416 244.992C94.424 246.736 92.824 248.08 90.616 249.024L89.768 247.664C91.976 246.656 93.464 245.376 94.248 243.84C94.584 243.104 94.856 242.304 95.048 241.424H90.008V239.952H95.32C95.416 239.152 95.48 238.32 95.512 237.424V236.464H91.048V234.976ZM115.672 238.032C115.608 238.288 115.544 238.528 115.48 238.752C115.832 240.416 116.296 241.872 116.856 243.12C117.384 241.648 117.672 239.952 117.736 238.032H115.672ZM116.168 244.672C115.624 243.568 115.144 242.32 114.744 240.928C114.488 241.504 114.232 242.048 113.944 242.528L112.984 241.344C113.88 239.584 114.488 237.216 114.808 234.24L116.296 234.496C116.2 235.232 116.104 235.92 115.976 236.576H120.04V238.032H119.112C119.016 240.64 118.536 242.864 117.672 244.704C118.472 246.032 119.4 247.072 120.488 247.808L119.64 249.04C118.6 248.288 117.704 247.296 116.936 246.064C116.184 247.232 115.24 248.224 114.12 249.024L113.336 247.76C114.52 246.96 115.464 245.936 116.168 244.672ZM108.584 241.68L110.008 241.856C109.912 242.112 109.832 242.352 109.736 242.608H113V243.84C112.712 244.8 112.2 245.648 111.464 246.384C112.12 246.672 112.76 246.992 113.368 247.312L112.552 248.496C111.928 248.112 111.176 247.728 110.296 247.328C109.24 248.016 107.912 248.56 106.328 248.976L105.624 247.728C106.824 247.44 107.864 247.088 108.728 246.64C108.072 246.368 107.368 246.096 106.632 245.808C107.016 245.136 107.368 244.512 107.672 243.904H105.992V242.608H108.248C108.376 242.288 108.488 241.968 108.584 241.68ZM110.072 245.808C110.776 245.248 111.288 244.608 111.64 243.904H109.16C108.936 244.352 108.696 244.784 108.44 245.2C109 245.392 109.544 245.584 110.072 245.808ZM107.48 234.496C107.832 235.104 108.136 235.744 108.408 236.448L107.32 236.944C107 236.176 106.648 235.488 106.28 234.896L107.48 234.496ZM112.072 234.48L113.144 234.992C112.824 235.664 112.424 236.336 111.928 236.992L110.872 236.448C111.384 235.776 111.784 235.12 112.072 234.48ZM106.024 237.216H109.048V234.272H110.44V237.216H113.224V238.544H110.44V238.624C111.288 238.976 112.152 239.392 113.032 239.856L112.232 241.056C111.528 240.496 110.936 240.048 110.44 239.728V241.52H109.048V238.816C108.52 239.968 107.64 240.976 106.408 241.84L105.656 240.608C106.776 239.968 107.56 239.28 108.04 238.544H106.024V237.216ZM123.64 248.88H122.28L121.96 247.44C122.36 247.504 122.744 247.552 123.128 247.552C123.48 247.552 123.672 247.344 123.672 246.928V243.488C123.096 243.696 122.536 243.888 121.976 244.08L121.592 242.576C122.296 242.416 122.984 242.208 123.672 241.968V238.656H121.88V237.2H123.672V234.304H125.144V237.2H126.552V238.656H125.144V241.392C125.592 241.184 126.056 240.96 126.504 240.72V242.208C126.04 242.432 125.592 242.656 125.144 242.864V247.296C125.144 248.352 124.632 248.88 123.64 248.88ZM128.616 241.936C128.408 244.624 127.8 246.992 126.776 249.04L125.592 247.984C126.664 245.92 127.208 243.264 127.224 240.016V234.8H135.88V238.944H132.968V240.544H136.264V241.936H132.968V243.584H135.544V249.024H134.136V248.336H130.344V249.024H128.936V243.584H131.496V241.936H128.616ZM131.496 238.944H128.696V240.016C128.696 240.192 128.68 240.368 128.68 240.544H131.496V238.944ZM130.344 246.992H134.136V244.928H130.344V246.992ZM134.408 236.192H128.696V237.584H134.408V236.192Z"
          fill="black"
        />
        <defs>
          <filter
            id="filter0_f_767_23227"
            x="18.7888"
            y="112.075"
            width="18.4899"
            height="18.4899"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="1.11124" result="effect1_foregroundBlur_767_23227" />
          </filter>
          <filter
            id="filter1_d_767_23227"
            x="110.674"
            y="93.9944"
            width="70.1178"
            height="67.9438"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="5.55618" />
            <feGaussianBlur stdDeviation="5.55618" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.568627 0 0 0 0 0.227451 0 0 0 0 0.937255 0 0 0 0.39 0"
            />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_767_23227" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_767_23227"
              result="shape"
            />
          </filter>
          <filter
            id="filter2_f_767_23227"
            x="46.0363"
            y="0.277528"
            width="29.6022"
            height="29.6022"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="1.11124" result="effect1_foregroundBlur_767_23227" />
          </filter>
          <linearGradient
            id="paint0_linear_767_23227"
            x1="105"
            y1="3.33704"
            x2="105"
            y2="213.337"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B5D2FF" stopOpacity="0" />
            <stop offset="0.555" stopColor="#B5D2FF" stopOpacity="0.06" />
            <stop offset="1" stopColor="#B5D2FF" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_767_23227"
            x1="117.88"
            y1="44.573"
            x2="117.88"
            y2="103.55"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#C8DEFF" />
            <stop offset="1" stopColor="#0064FF" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_767_23227"
            x1="109.5"
            y1="67.5"
            x2="107.545"
            y2="143.921"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#CDE1FF" />
            <stop offset="1" stopColor="#0064FF" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_767_23227"
            x1="134.112"
            y1="68.809"
            x2="134.112"
            y2="103.646"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#C5DCFF" />
            <stop offset="1" stopColor="#0064FF" />
          </linearGradient>
          <linearGradient
            id="paint4_linear_767_23227"
            x1="63.6768"
            y1="119.494"
            x2="63.6768"
            y2="143.921"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#EBF3FF" />
            <stop offset="1" stopColor="#0064FF" />
          </linearGradient>
          <linearGradient
            id="paint5_linear_767_23227"
            x1="81.4329"
            y1="90.7191"
            x2="81.4329"
            y2="143.899"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#E0ECFF" />
            <stop offset="1" stopColor="#0064FF" />
          </linearGradient>
          <linearGradient
            id="paint6_linear_767_23227"
            x1="103.896"
            y1="125.944"
            x2="103.896"
            y2="166.354"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#0064FF" />
            <stop offset="1" stopColor="#0064FF" stopOpacity="0" />
          </linearGradient>
          <linearGradient
            id="paint7_linear_767_23227"
            x1="152.992"
            y1="85.2527"
            x2="152.992"
            y2="125.977"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#CEE1FF" />
            <stop offset="1" stopColor="#0064FF" />
          </linearGradient>
          <linearGradient
            id="paint8_linear_767_23227"
            x1="126.351"
            y1="112.051"
            x2="145.733"
            y2="145.27"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#8231EA" />
            <stop offset="1" stopColor="#CA5AFF" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  )
}

export default EmptyContent
